"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _vuex = require("vuex");
var _default = exports.default = {
  name: 'Exception403',
  computed: {
    ...(0, _vuex.mapGetters)(['firstMenuPath'])
  },
  methods: {
    toHome() {
      this.$router.push(this.firstMenuPath);
    }
  }
};